import React from 'react';
import { Redirect } from 'react-router-dom';

const LegacyArticleRedirect = ({ match }) => {
  const legacyId = match?.params?.legacyId;

  if (!legacyId) {
    return null;
  }

  return <Redirect to={`/articles/${legacyId}`} />;
};

export default LegacyArticleRedirect;
